import React from "react";
import SEO from "../components/SEO";
import { useContent } from "../lib/content";
import { getImageUrl } from "../lib/api";
import { Leaf, ShieldCheck, Heart, Sprout, Droplet, Flower2, Grape, Award, Sparkles } from "lucide-react";
import ImageWithSkeleton from "../components/ImageWithSkeleton";

const ICON_MAP = { Leaf, ShieldCheck, Heart, Sprout, Droplet, Flower2, Grape, Award, Sparkles };

export default function AboutPage() {
  const { about } = useContent();

  return (
    <>
      <SEO title="درباره تحسین" description={about.intro_paragraphs?.[0]?.slice(0, 160)} />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-right" data-testid="about-page">
        {about.eyebrow && (
          <span className="text-amber-700 font-semibold text-sm tracking-widest uppercase">{about.eyebrow}</span>
        )}
        <h1 className="text-4xl sm:text-5xl font-black text-stone-900 mt-3 mb-6">{about.title}</h1>

        {(about.intro_paragraphs || []).map((p, i) => (
          <p key={i} className={`${i === 0 ? "text-lg" : ""} text-stone-600 leading-relaxed mb-6`}>{p}</p>
        ))}

        {about.image && (
          <div className="relative w-full aspect-[16/8] rounded-3xl my-10 shadow-lg overflow-hidden">
            <ImageWithSkeleton
              src={getImageUrl(about.image)}
              alt={about.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        )}

        {(about.values || []).length > 0 && (
          <>
            <h2 className="text-3xl font-black text-stone-900 mt-12 mb-6">{about.values_title || "ارزش‌های ما"}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {about.values.map((v, i) => {
                const Icon = ICON_MAP[v.icon] || Leaf;
                return (
                  <div key={i} className="bg-white border border-stone-200 rounded-3xl p-6 product-card-hover" data-testid={`about-value-${i}`}>
                    <div className="w-12 h-12 rounded-2xl honey-gradient flex items-center justify-center mb-4">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-stone-900 mb-2">{v.title}</h3>
                    <p className="text-stone-600 leading-relaxed">{v.desc}</p>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </section>
    </>
  );
}
